<template>
  <div v-loading.body="loading">
    <div class="page-header">

      <el-dropdown class="page-menu" trigger="click" v-if="$route.params.area=='invitation'" @command="invitationMenu">
        <span class="el-dropdown-link"><i class="material-icons">more_vert</i></span>
        <el-dropdown-menu slot="dropdown" style="min-width: 50px;color:#666666;">
          <el-dropdown-item command="president-invitation" v-if="$route.params.page!='president-invitation'">President's Invitation</el-dropdown-item>
          <el-dropdown-item command="society-invitation" v-if="$route.params.page!='society-invitation'">IFCC President invitation</el-dropdown-item>
          <el-dropdown-item command="auspices" v-if="$route.params.page!='auspices'">Auspices</el-dropdown-item>
          <el-dropdown-item command="mayor-of-athens" v-if="$route.params.page!='mayor-of-athens'">Mayor of Athens</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>

      <el-dropdown class="page-menu" trigger="click" v-if="$route.params.area=='info'" @command="infoMenu">
        <span class="el-dropdown-link"><i class="material-icons">more_vert</i></span>
        <el-dropdown-menu slot="dropdown" style="min-width: 50px;color:#666666;">
          <el-dropdown-item command="congress-venue" v-if="$route.params.page!='congress-venue'">Congress venue</el-dropdown-item>
          <el-dropdown-item command="reach-maicc" v-if="$route.params.page!='reach-maicc'">How to reach MAICC</el-dropdown-item>
          <el-dropdown-item command="get-athens" v-if="$route.params.page!='get-athens'">How to get Athens</el-dropdown-item>
          <el-dropdown-item command="metromap" >Metro MAP</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>

      <div class="title"  v-html="title"></div> 
    </div>
     
	<div class="page-in"><div class="page-pad" v-html="page"></div></div>

  <!-- <div>{{$teras.onesignal}}</div> -->
   
  </div>
</template>

<script>
  
export default {
  data () {
    return {
      loading: true,
      title: '',
      page:''
    }
  },
  created () {
    console.log("Arrivo al site-page.vue con page  "+this.$route.params.page);
    // fetch the data when the view is created and the data is
    // already being observed
    this.fetchData()
    this.$teras.pageHeader = 40
  },
  watch: {
    // call again the method if the route changes
    '$route': 'fetchData'
  },
  methods: {
    fetchData () {
      this.loading = true      
      var parent = this
      this.axios.get('page/'+this.$route.params.page+'.html',{responseType: 'document'})
        .then(function (response) {
          parent.title = response.request.response.body.children.item(0).innerHTML
          parent.page = response.request.response.body.children.item(1).innerHTML
          parent.loading = false
        })
        .catch(function (error) {
          console.log(error)
          parent.$route.push('/inside/error/not-find')
        })
    },
    invitationMenu(command) {
      this.$router.push('/page/invitation/' + command);
    },
    infoMenu(command) {
      if(command=='metromap'){
        this.$router.push('/map/metro')
      }else{
        this.$router.push('/page/info/' + command)
      }
    }
  }
  
}

</script>
<style>
.vue-page{
  
}.vue-page-pdf{
  margin-left:0;
  margin-right:0;
  
}.app-page .page-header{
  /* position:fixed;
  z-index:990;
  top:52px;
  left:0;right:0;
  */
  padding:3px 5px 3px 5px;
  height:40px;
  background:#29B7C4;
  color:#424F5C;
  font-size:2.4rem;
  line-height: 32px;
}.app-page .page-header .title{
  text-align: center;
}.app-page .page-in{
  text-align: justify;
  min-height: 100vh;
  margin:0 auto 20px auto;
  max-width: 680px;
}.app-page .page-in .page-pad{
  padding:0 4px;
}.app-page .page-footer{
  /* position:fixed;
  margin-top:0;
  left:0;right:0;bottom:0;
  */
  background:#2E3C4A;
}.app-page .page-menu{
  float:right;
}.app-page .page-menu span i{
  font-size:2.8rem;
  line-height: 32px;
}.app-page .go-home{
  float:left;
  color:#424F5C;
}.app-page .go-home i{
  font-size:3.8rem;
  line-height: 32px;
  
}



</style>



// WEBPACK FOOTER //
// Page.vue?a134f656